// @theme component
import { useAppSelector } from '@core/js/store/hooks';
import { prop } from 'ramda';
import { useMemo } from 'react';

const useDTAG = <T = string>(name: string, parseFn?: (name: string| undefined) => T): T | undefined => {
    const dynamicTags = useAppSelector<{ [key: string]: string | undefined }>(prop('dynamicTags'));

    const dynamicTagValue = useMemo(() => {
        const dtagName = `${!name.includes('DTAG_') ? 'DTAG_' : ''}${name}`;

        try {
            const dtagValue = dynamicTags[dtagName];

            if (!dtagValue) {
                console.warn(`DTAG *${dtagName}* doesn't exists or empty`);
                return;
            }

            return parseFn?.(dtagValue) || dtagValue as unknown as T;
        } catch (e) {
            console.warn(`INVALID DTAG FORMAT, PLEASE FIX *${dtagName}* Dynamic Tag`);
        }
    }, [dynamicTags, name, parseFn]);

    return dynamicTagValue;
};

export { useDTAG };
